// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'
import MultiSelectFromState from 'components/Form/common/MultiSelectFromState'

const targetSet= ['antennaCompanies']

const AntennaManufacturer = ({ idRoot }) => (
  <Field
    component={MultiSelectFromState}
    id={idRoot}
    label={''}
    name={'antennaCompanyId'}
    labelKey={'companyName'}
    targetSet={targetSet}
    valueKey={'companyId'} />
)

AntennaManufacturer.propTypes = {
  idRoot: string.isRequired,
}

export default AntennaManufacturer